import React, { useEffect, useMemo } from 'react';
import { useRecoilState, useRecoilValue } from 'recoil';
import { useHistory } from 'react-router-dom';

import { Container, ButtonPrimary } from 'components';
import { storageCurrentRmaSelector } from 'state/selectors';
import { defaultCurrentRmaState } from 'state/defaults';

import { MessageWrapper } from './styledComponents';
import { accountState } from 'state/atoms';

const NewCaseConfirmation = () => {
  const [{ caseNumber }, setCurrentRma] = useRecoilState(storageCurrentRmaSelector);
  const account = useRecoilValue(accountState);
  const history = useHistory();

  useEffect(() => {
    if (!caseNumber) {
      history.replace('/');
    } else {
      setCurrentRma({ ...defaultCurrentRmaState, currencyCode: account.defaultCurrencyCode });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return useMemo(
    () => (
      <Container>
        <MessageWrapper>
          <h1>RMA Request Confirmation</h1>
          <p>
            Your RMA Case # {caseNumber} has been submitted.
            <br />
            You will receive a confirmation email shortly.
          </p>
          <ButtonPrimary onClick={() => history.push('/')}>CLOSE</ButtonPrimary>
        </MessageWrapper>
      </Container>
    ),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );
};

export { NewCaseConfirmation };
